/* =========================================================
   REVIAR — reviar-password.js
   Countdown timer, password toggle, SMS submit stub.
   ========================================================= */
(function () {
  'use strict';

  /* ---------- COUNTDOWN ---------- */
  var cd = document.querySelector('.rvp-countdown');
  if (cd && cd.dataset.target) {
    var target = new Date(cd.dataset.target).getTime();
    if (!isNaN(target)) {
      var d = cd.querySelector('[data-cd="days"]');
      var h = cd.querySelector('[data-cd="hours"]');
      var m = cd.querySelector('[data-cd="minutes"]');
      var s = cd.querySelector('[data-cd="seconds"]');

      var pad = function (n) { return n < 10 ? '0' + n : String(n); };

      var tick = function () {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (d) d.textContent = '00';
          if (h) h.textContent = '00';
          if (m) m.textContent = '00';
          if (s) s.textContent = '00';
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        if (d) d.textContent = pad(days);
        if (h) h.textContent = pad(hours);
        if (m) m.textContent = pad(mins);
        if (s) s.textContent = pad(secs);
      };
      tick();
      cd.classList.add('is-visible');
      setInterval(tick, 1000);
    }
  }

  /* ---------- PASSWORD ENTRY TOGGLE ---------- */
  var gate = document.querySelector('.rvp-passgate');
  if (gate) {
    var toggle = gate.querySelector('.rvp-passgate__toggle');
    toggle.addEventListener('click', function () {
      var open = gate.getAttribute('data-open') === 'true';
      gate.setAttribute('data-open', open ? 'false' : 'true');
      if (!open) {
        setTimeout(function () {
          var input = gate.querySelector('.rvp-passgate__input');
          if (input) input.focus();
        }, 250);
      }
    });

    // If Shopify returns a password error via ?password_error=1, show it
    // (Shopify redirects with a flash message inside {{ content_for_layout }};
    // this block is a defensive fallback for when the browser preserves state)
    if (/password.*(incorrect|wrong)/i.test(document.body.innerText)) {
      gate.setAttribute('data-open', 'true');
      var err = gate.querySelector('.rvp-passgate__error');
      if (err) err.classList.add('is-visible');
    }
  }

  /* ---------- SMS FORM ---------- */
  var form = document.querySelector('.rvp-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var tel = form.querySelector('input[type="tel"]');
      if (!tel || tel.value.replace(/\D/g, '').length < 7) {
        tel.focus();
        return;
      }
      /* ================================================================
         SMS PROVIDER INTEGRATION POINT
         Replace with your Postscript / SMSBump handler.
         Data to send:
           country: form.querySelector('select').value
           phone:   tel.value
         ================================================================ */
      form.classList.add('is-done');
    });
  }
})();
